import { render, staticRenderFns } from "./CustomerVehicleForm.vue?vue&type=template&id=d84f770e"
import script from "./CustomerVehicleForm.vue?vue&type=script&lang=js"
export * from "./CustomerVehicleForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerVehicleForm.vue?vue&type=style&index=0&id=d84f770e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports